import React from 'react';
import { showErrorMessage } from '@/shared/components/toast-system';

const MAX_SILENT_RETRIES = 2;
const RETRY_WINDOW_MS = 10000;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.errorTimestamps = [];
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    const now = Date.now();
    this.errorTimestamps = this.errorTimestamps.filter((t) => now - t < RETRY_WINDOW_MS);
    this.errorTimestamps.push(now);

    showErrorMessage('Something went wrong. Please try again.');

    if (this.errorTimestamps.length <= MAX_SILENT_RETRIES) {
      // Silently reset and let the app re-render
      this.setState({ hasError: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.location !== this.props.location) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
